import React, { Component } from 'react';
import GeneralSettings from '.';
import { inject, observer } from 'mobx-react';

@inject('routesStore') @observer
export default class GeneralSettingsContainer extends Component {

    
    componentDidMount() {

        this.props.routesStore.setSettingsSelectedTabId(this.props.tabId);
    }

    render() {

        return (
            <GeneralSettings />
        );
    }
}